import axios from 'axios';
import React, { useEffect, useState } from 'react';

const Logo = () => {
  const style = {
    width: '30%',
    marginLeft: `2%`,
    height: '80%'
  };

  const [logo, setLogo] = useState('');

  const getLogo = (retries = 2, interval = 1000) => {
    axios
      .get('api/logo/get')
      .then((response) => {
        setLogo(response.data);
      })
      .catch(function (error) {
        console.log(error);
        if (retries > 0) {
          setTimeout(() => getLogo(retries - 1, interval), interval);
        }
      });
  };

  useEffect(() => {
    getLogo();
  }, []);

  return (
    <div className="headerLogo">
      <img style={style} src={`data:image/jpg;base64, ${logo}`} alt="ci" />
    </div>
  );
};

export default Logo;
